<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0"><WarningRequiredFields /></div>
    <div class="col-md-6 pt-0 pb-0">
      <LabelRequiredField label="De" />
      <select class="form-control" v-model="origin_account_id">
        <option
          v-for="item in finance_configuration_account"
          :key="item.id"
          :value="item.id"
        >
          {{
            `${item.account_nickname} - ${formatValueOnKeyUp(
              item.balance_date
            )}`
          }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <LabelRequiredField label="Para" />
      <select class="form-control" v-model="destination_account_id">
        <option
          v-for="item in finance_configuration_account"
          :key="item.id"
          :value="item.id"
        >
          {{
            `${item.account_nickname} - ${formatValueOnKeyUp(
              item.balance_date
            )}`
          }}
        </option>
      </select>
    </div>
    <div class="col-md-12 pt-0 pb-0"><hr /></div>
    <div class="col-md-4 pt-0 pb-0">
      <LabelRequiredField label="Quando" />
      <input type="date" class="form-control" v-model="date" />
    </div>
    <div class="col-md-12 pt-0 pb-0"></div>
    <div class="col-md-8 pt-0 pb-0">
      <LabelRequiredField label="Descrição" />
      <input type="text" class="form-control" v-model="description" />
    </div>
    <div class="col-md-4 pt-0 pb-0">
      <LabelRequiredField label="Valor" />
      <input
        type="text"
        class="form-control"
        v-model="value"
        @input="handleInputValue($event.target.value)"
      />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Centro de custo/lucro</label>
      <select
        class="form-control"
        v-model="finance_configuration_profit_cost_center_id"
      >
        <option
          v-for="item in finance_configuration_profit_cost_center"
          :key="item.id"
          :value="item.id"
        >
          {{ item.description }}
        </option>
      </select>
    </div>
    <div class="col-md-12 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6 pb-0">
      <v-btn class="btn-cancel mr-2" @click="handleCancel"
        ><i class="fas fa-times mr-2"></i>CANCELAR
      </v-btn>
    </div>
    <div class="col-md-6 pb-0 text-right">
      <v-btn :disabled="loading" @click="update" class="btn-save ml-2"
        ><i class="fas fa-check mr-2"></i
        >{{ loading ? "CARREGANDO" : "SALVAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../../Components/LabelRequiredField";

import WarningRequiredFields from "../../../../Components/WarningRequiredFields";

import { formatValueOnKeyUp } from "../../../../../lib/format";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "EditTransfer",
  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
  },
  props: {
    data: Object,
    finance_configuration_account: Array,
    finance_configuration_profit_cost_center: Array,
  },
  data() {
    return {
      origin_account_id: "",
      destination_account_id: "",
      date: "",
      description: "",
      value: "",
      finance_configuration_profit_cost_center_id: "",
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatValueOnKeyUp,
    handleInputValue(value) {
      this.value = formatValueOnKeyUp(value);
    },
    retrieve() {
      let { data } = this;

      this.origin_account_id = data.origin_account_id;
      this.destination_account_id = data.destination_account_id;
      this.date = moment(data.paid_in_date).format("YYYY-MM-DD");
      this.description = data.description;
      this.value = formatValueOnKeyUp(String(data.value));
      this.finance_configuration_profit_cost_center_id =
        data.items[0].finance_configuration_profit_cost_center_id;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async update() {
      try {
        this.loading = true;

        const {
          data,
          origin_account_id,
          destination_account_id,
          date,
          description,
          value,
          finance_configuration_profit_cost_center_id,
        } = this;

        let params = {
          id: data.id,
          origin_account_id,
          destination_account_id,
          date,
          description,
          value,
          finance_configuration_profit_cost_center_id,
        };

        const response = await api.put(
          "/rest-home/financial/launch/transfer",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>